import { render, staticRenderFns } from "./expert_view.vue?vue&type=template&id=e6058506&scoped=true&"
import script from "./expert_view.vue?vue&type=script&lang=js&"
export * from "./expert_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6058506",
  null
  
)

export default component.exports